import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * General-purpose overlay component that can display custom content
 * with optional backdrop blur effect.
 *
 * Usage:
 * <lib-cdw-overlay [blur]="true" [size]="'medium'">
 *   <div class="your-custom-content">
 *     Your content here
 *   </div>
 * </lib-cdw-overlay>
 *
 * Note: The containing element should have position: relative
 */
@Component({
  selector: 'lib-cdw-overlay',
  imports: [CommonModule],
  templateUrl: './cdw-overlay.component.html',
  styleUrl: './cdw-overlay.component.scss',
})
export class CdwOverlayComponent {
  /** Enable backdrop blur effect */
  @Input() blur = false;

  /** Size of the overlay content area */
  @Input() size: 'small' | 'medium' | 'large' | 'full' = 'medium';

  /** Background opacity (0-1) */
  @Input() opacity = 0.95;

  get sizeClass(): string {
    return `overlay-${this.size}`;
  }
}
